import React from "react";
import { Redirect, Route } from "react-router-dom";
import { useWebContext } from "./../contexts/WebContext";

export default function AdminRoute({ component: Component, ...rest }) {
  const { currentUser } = useWebContext();
  return (
    <Route
      {...rest}
      render={(props) => {
        return currentUser ? (
          <Component {...props} />
        ) : (
          <Redirect to="/signin" />
        );
      }}
    />
  );
}
